import { FormControl, FormControlLabel, Radio, RadioGroup, RadioGroupProps, Typography } from '@mui/material';
import { useController, useFormContext, RegisterOptions } from 'react-hook-form';

type Option = {
  value: string;
  label: string;
};

type Props = RadioGroupProps & {
  name: string;
  options: Option[];
  label?: string;
  defaultValue?: string;
  rules?: RegisterOptions;
  disabled?: boolean;
};

const FormRatio = ({ name, label, defaultValue = '', disabled, rules, options, sx, ...rest }: Props) => {
  const { field } = useController({ name, defaultValue, rules });
  const {
    formState: { errors },
  } = useFormContext<{ [key: string]: string }>();
  const error = errors[name];

  return (
    <FormControl fullWidth sx={sx} error={!!error}>
      <RadioGroup {...rest} {...field}>
        {label && <Typography>{label}</Typography>}
        {options.map((option) => (
          <FormControlLabel
            disabled={disabled}
            key={option.value}
            value={option.value}
            control={<Radio disabled={disabled} />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default FormRatio;
